import { storeToRefs } from 'pinia'
import { useAuthStore } from '~/stores/auth'

export default defineNuxtRouteMiddleware(to => {
    const { isAuth, isProfileCompleted, isRejected, isUnderReview } = storeToRefs(useAuthStore())

    if (!isAuth.value) {
        return navigateTo('/login')
    }
    const isEditingProfile = to.query.isEditProfile === 'true' || to.query.isEdit === 'true'

    if (isUnderReview.value && isEditingProfile) {
        return navigateTo('/dashboard')
    }

    if (isProfileCompleted.value && !isRejected.value && !isEditingProfile) {
        return navigateTo('/dashboard')
    }
})
